const map = {
	"./card-fan-1.ogg": 7187,
	"./card-fan-2.ogg": 5336,
	"./card-place-1.ogg": 7001,
	"./card-place-2.ogg": 8026,
	"./card-place-3.ogg": 2535,
	"./card-place-4.ogg": 368,
	"./card-shove-1.ogg": 8559,
	"./card-shove-2.ogg": 628,
	"./card-shove-3.ogg": 6017,
	"./card-shove-4.ogg": 3558,
	"./card-shuffle.ogg": 8657,
	"./card-slide-1.ogg": 7319,
	"./card-slide-2.ogg": 2060,
	"./card-slide-3.ogg": 2838,
	"./card-slide-4.ogg": 4366,
	"./card-slide-5.ogg": 4667,
	"./card-slide-6.ogg": 6800,
	"./card-slide-7.ogg": 3805,
	"./card-slide-8.ogg": 8258,
	"./cards-pack-open-1.ogg": 507,
	"./cards-pack-open-2.ogg": 2016,
	"./cards-pack-take-out-1.ogg": 2189,
	"./cards-pack-take-out-2.ogg": 6270,
	"./chip-lay-1.ogg": 198,
	"./chip-lay-2.ogg": 421,
	"./chip-lay-3.ogg": 7144,
	"./chips-collide-1.ogg": 645,
	"./chips-collide-2.ogg": 3974,
	"./chips-collide-3.ogg": 3395,
	"./chips-collide-4.ogg": 5572,
	"./chips-handle-1.ogg": 2805,
	"./chips-handle-2.ogg": 4438,
	"./chips-handle-3.ogg": 7379,
	"./chips-handle-4.ogg": 8228,
	"./chips-handle-5.ogg": 5265,
	"./chips-handle-6.ogg": 2962,
	"./chips-stack-1.ogg": 3567,
	"./chips-stack-2.ogg": 6004,
	"./chips-stack-3.ogg": 1137,
	"./chips-stack-4.ogg": 9686,
	"./chips-stack-5.ogg": 5155,
	"./chips-stack-6.ogg": 552,
	"./dice-grab-1.ogg": 7841,
	"./dice-grab-2.ogg": 146,
	"./dice-shake-1.ogg": 6101,
	"./dice-shake-2.ogg": 1014,
	"./dice-shake-3.ogg": 2851,
	"./dice-throw-1.ogg": 8063,
	"./dice-throw-2.ogg": 775,
	"./dice-throw-3.ogg": 7937,
	"./die-throw-1.ogg": 272,
	"./die-throw-2.ogg": 8139,
	"./die-throw-3.ogg": 1809,
	"./die-throw-4.ogg": 3929
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3154;